// @flow

module.exports = {
  HEAD_ELEMENT_KEY_GOOGLE_MAPS: 'headElementGoogleMaps',
  IMAGE_FALLBACK_FACILITY:
    'https://medimakr-web.s3.ap-south-1.amazonaws.com/facility-placeholder.jpg',
  IMAGE_FALLBACK_COMPANY:
    'https://medimakr-web.s3.ap-south-1.amazonaws.com/company-placeholder.jpg',
  DATA_LAYER_NAME: 'dataLayer',
  MY_CLIENT_ID: 'ASWDTxw0L_wIv242G_nGf4YGHC44tfXvPw5O-ayh0CTOtm-MUG0YHWQ96EZ21iOa3156PCkqqj0Ejhzt',
  DELHI_CENTER: { lat: 28.7041, lng: 77.1025 },
  PRODUCTION_HOSTNAMES: ['medimakr.com', 'www.medimakr.com'],
  IOS_APP_LINK: 'https://apps.apple.com/de/app/medimakr/id1454789613',
  ANDROID_APP_LINK: 'https://play.google.com/store/apps/details?id=com.medimakr',
  LANGUAGES: ['en', 'ar'],
  MASK_BOTTOM_RIGHT_SLANT: 'https://www.datcms-assets.com/18250/1579869639-slantbottomright.png',
  MASK_RIGHT_BOTTOM_SLANT: 'https://www.datcms-assets.com/18250/1579871667-slantrightbottom-1.png',
  GOOGLE_MAPS_API_KEY: 'AIzaSyAFFcFZ_PEM88SqT6co-WlGpdd34UksBZQ'
};
